module.exports = __webpack_public_path__ + "img/animacare.452dfb1e.png";